"use client";
import clsx from "clsx";
import { type ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "ui/iconsN";

type Props = {
  children: ReactNode;
};
export const BoatDescription = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const topBeforeToggle = useRef<number | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const check = () => {
      if (!element.classList.contains("line-clamp-4")) return;
      setIsClamped(element.scrollHeight > element.clientHeight + 1);
    };
    check();

    const observer = new ResizeObserver(check);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(() => {
    if (topBeforeToggle.current === null || !ref.current) return;

    window.scrollBy(0, ref.current.getBoundingClientRect().top - topBeforeToggle.current);
    topBeforeToggle.current = null;

    if (!isExpanded) ref.current.scrollIntoView({ block: "nearest" });
  }, [isExpanded]);

  const toggle = () => {
    topBeforeToggle.current = ref.current?.getBoundingClientRect().top ?? null;
    setIsExpanded((e) => !e);
  };

  return (
    <>
      <div ref={ref} className={clsx("mt-4 scroll-mt-36", { "line-clamp-4 overflow-hidden": !isExpanded })}>
        {children}
      </div>
      {isClamped && (
        <button
          type="button"
          aria-expanded={isExpanded}
          onClick={toggle}
          className="mt-3 -ml-1.5 inline-flex items-center gap-1.5 px-1.5 py-1 rounded text-sm font-medium text-tx-1 opacity-40 hover:opacity-70 transition-opacity cursor-pointer"
        >
          {isExpanded ? "Voir moins" : "Voir plus"}
          <ChevronDownIcon className={clsx("size-3.5 transition-transform", { "rotate-180": isExpanded })} />
        </button>
      )}
    </>
  );
};
